import { Transition } from '@headlessui/react'

type AlertProps = {
  children?: JSX.Element
  onClose: () => void
  show: boolean
  variant?: String
  dismissible?: boolean
  styles?: String
}

const Alert = ({
  children, onClose, show, variant, dismissible = false, styles = ''
} : AlertProps) => {
  let theme = ''
  let dismissTheme = ''
  if (variant === 'success') {
    theme = 'text-green-700 bg-green-100 border-green-600 '
    dismissTheme = 'text-green-600'
  } else if (variant === 'warning') {
    theme = 'text-yellow-700 bg-yellow-100 border-yellow-600 '
    dismissTheme = 'text-yellow-600'
  } else if (variant === 'danger') {
    theme = 'text-red-700 bg-red-100 border-red-600 '
    dismissTheme = 'text-red-600'
  }
  return (
    <Transition
      show={show}
      enter="transition-opacity duration-200"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={`flex px-4 py-3 border rounded ${theme}${styles}`} role="alert">
        {children}
        <span className={`${dismissible ? '':'hidden'} px-2`}>
          <svg className={`w-6 h-6 ${dismissTheme} fill-current`} role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
            onClick={onClose}>
            <title>Close</title>
          <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
        </span>
      </div>
    </Transition>
  )
}

export default Alert